// extracted by mini-css-extract-plugin
export default {"list_container":"CartItemsList_list_container__JGIvR","dotted_line":"CartItemsList_dotted_line__eFBXW"};